module.exports = __webpack_public_path__ + "static/media/account.4d311a97.svg";